module.exports = __webpack_public_path__ + "img/fronius-inverter-sm.071c059f.svg";